import {
  getPropertyCollectionRef,
  getPropertyRef,
  getUserCollectionRef,
  getUserRef,
} from "../../../firebase/collectionReferences";
import {
  serverTimestamp,
  updateDoc,
  getDocs,
  query,
  where,
  arrayRemove,
} from "firebase/firestore";

export async function editProperty(data) {
  const { name, url, country, id } = data;

  const propertyRef = getPropertyRef(id);
  await updateDoc(propertyRef, {
    id,
    name,
    url,
    country,
  });
  return id;
}

export async function deleteProperty(data) {
  const { propertyId, assigned_property_ids, userId } = data;

  const propertyRef = getPropertyRef(propertyId);

  await updateDoc(propertyRef, {
    deleted_at: serverTimestamp(),
    status: "archived",
  });

  const userRef = getUserRef(userId);

  await updateDoc(userRef, {
    assigned_property_ids,
  });
}

export async function getUsersByPropertyIds(propertyUsers) {
  let usersRef = await getUserCollectionRef();
  const usersQuery = query(usersRef, where("id", "in", propertyUsers));

  return (await getDocs(usersQuery)).docs.map((row) => ({
    ...row.data(),
    id: row.id,
  }));
}

export async function deletePropertyFromUsers(users, propertyId) {
  const usersWithProperty = users?.filter((user) =>
    user.assigned_property_ids.includes(propertyId)
  );

  usersWithProperty?.forEach((user) => {
    const userRef = getUserRef(user.id);
    updateDoc(userRef, {
      assigned_property_ids: arrayRemove(propertyId),
    });
  });
}

export async function userCreatedPropertyCount(userId) {
  let propertyRef = await getPropertyCollectionRef();
  const propertyQuery = query(propertyRef, where("createdById", "==", userId));

  const propertySnapshot = await getDocs(propertyQuery);
  const propertyCount = propertySnapshot.size;

  return propertyCount;
}

export async function updateProperty(data) {
  const { id } = data;
  const propertyRef = getPropertyRef(id);
  await updateDoc(propertyRef, {
    status: data?.status || "",
  });
  return id;
}
